module.exports = __webpack_public_path__ + "static/media/flash@3x.026e56e5.png";